export enum BusinessPartnerRoutes {
  Devices = 'devices',
  AdditionalDevices = 'additional-devices',
  Admins = 'admins',
  Doctors = 'doctors',
  FamilyUsers = 'family-users',
  Patients = 'patients',
  MedicalOperators = 'medical-operators',
  MyPartners = 'my-partners',
}
